<div class="terms-page-wrapper">
    <!-- Hero Section -->
    <section class="terms-hero">
        <div class="container">
            <h1 class="page-title">Terms of Use</h1>
            <p class="effective-date">Effective Date: May 11, 2026</p>
        </div>
    </section>

    <!-- Breadcrumb -->
    <div class="breadcrumb-nav">
        <div class="container">
            <p><a (click)="nav('/')">Home</a> / <span>Terms of Use</span></p>
        </div>
    </div>

    <!-- Content Section -->
    <section class="content-body">
        <div class="container">
            <div class="legal-card">

                <div class="intro-text">
                    <p>Welcome to <a href="https://www.kalpitatechnologies.com" target="_blank"
                            class="bold-link">Kalpita Technologies</a>. These Terms of Use (“Terms”) govern your access
                        to and use of the websites, applications, platforms, services, content, and digital properties
                        owned or operated by Kalpita Technologies (“Kalpita,” “we,” “our,” or “us”).</p>
                    <p class="highlight-box">By accessing or using this website, you agree to comply with and be bound
                        by these Terms. If you do not agree with these Terms, please discontinue the use of this website
                        immediately.</p>
                </div>

                <div class="legal-section">
                    <h2>1. Acceptance of Terms</h2>
                    <p>By accessing, browsing, or using this website, you acknowledge that you have read, understood,
                        and agreed to these Terms of Use and our applicable policies, including our Privacy Policy. </p>
                    <p>These Terms apply to all visitors, users, clients, applicants, vendors, partners, and others who
                        access the website.</p>
                </div>

                <div class="legal-section">
                    <h2>2. About Kalpita Technologies</h2>
                    <p>Kalpita Technologies is an IT consulting and software development company delivering digital
                        transformation solutions, custom software development, cloud services, AI-powered solutions,
                        data engineering, enterprise applications, mobile applications, and related technology services
                        across industries including Insurtech, Fintech, Healthcare, E-commerce, and Hi-tech(<a
                            href="https://www.kalpitatechnologies.com" target="_blank" class="bold-link">Kalpita
                            Technologies Private Limited</a>).</p>
                </div>

                <div class="legal-section">
                    <h2>3. Use of Website</h2>
                    <p>You agree to use this website only for lawful purposes and in accordance with these Terms.</p>
                    <p>You shall not:</p>
                    <ul>
                        <li>Use the website in any way that violates applicable laws or regulations.</li>
                        <li>Attempt unauthorized access to systems, servers, or networks connected to the website.</li>
                        <li>Introduce viruses, malware, or other harmful technologies.</li>
                        <li>Copy, reproduce, or exploit website content without prior written permission.</li>
                        <li>Interfere with the operation, security, or performance of the website.</li>
                        <li>Misrepresent your identity or provide false information through forms or communications.
                        </li>
                    </ul>
                    <p>Kalpita reserves the right to restrict or terminate access to users who violate these Terms.</p>
                </div>

                <div class="legal-section">
                    <h2>4. Intellectual Property Rights</h2>
                    <p>All content available on this website, including but not limited to:</p>
                    <ul>
                        <li>Text</li>
                        <li>Graphics</li>
                        <li>Logos</li>
                        <li>Icons</li>
                        <li>Images</li>
                        <li>Videos</li>
                        <li>Software</li>
                        <li>Code</li>
                        <li>Designs</li>
                        <li>Trademarks</li>
                        <li>Service Marks</li>
                        <li>Documents</li>
                        <li>Case Studies</li>
                        <li>Whitepapers</li>
                        <li>Blogs</li>
                    </ul>
                    <p>are owned by or licensed to Kalpita Technologies and are protected under applicable intellectual
                        property laws.</p>
                    <p>No content from this website may be copied, modified, republished, uploaded, transmitted,
                        distributed, or commercially exploited without prior written consent from Kalpita Technologies.
                    </p>
                    <p>Unauthorized use may violate copyright, trademark, and other applicable laws.</p>
                </div>

                <div class="legal-section">
                    <h2>5. User Submissions and Information</h2>
                    <p>Users may voluntarily submit information through contact forms, career applications, newsletter
                        subscriptions, event registrations, downloads, or other interactions on the website.</p>
                    <p>By submitting information, you:</p>
                    <ul>
                        <li>Confirm that the information provided is accurate and lawful.</li>
                        <li>Grant Kalpita the right to use the submitted information for business, communication,
                            recruitment, marketing, support, or service-related purposes.</li>
                        <li>Agree not to submit confidential, unlawful, offensive, or infringing content.</li>
                    </ul>
                    <p>Kalpita reserves the right to remove or reject submissions that violate applicable laws or these
                        Terms.</p>
                </div>

                <div class="legal-section">
                    <h2>6. Careers and Recruitment</h2>
                    <p>The website may contain job postings, career opportunities, or recruitment-related information.
                    </p>
                    <p>Submission of an application through this website does not guarantee employment, interview
                        selection, or job placement.</p>
                    <p>Applicants are responsible for ensuring the accuracy of the information shared in resumes,
                        profiles, and supporting documents.</p>
                    <p>Kalpita Technologies reserves the right to modify, withdraw, or close job openings without prior
                        notice.</p>
                </div>

                <div class="legal-section">
                    <h2>7. Third-Party Links</h2>
                    <p>This website may contain links to third-party websites, tools, services, or external resources
                        for user convenience.</p>
                    <p>Kalpita Technologies does not endorse, control, or guarantee the accuracy, availability, or
                        security of third-party content or websites. Accessing third-party websites is at your own risk
                        and subject to their respective terms and policies.</p>
                </div>

                <div class="legal-section">
                    <h2>8. Confidential Information</h2>
                    <p>Information shared through this website shall not be considered confidential unless explicitly
                        agreed otherwise through a written agreement or contractual arrangement.</p>
                    <p>Users are advised not to submit sensitive business, financial, proprietary, or confidential
                        information through public forms or unsecured communication channels.</p>
                </div>

                <div class="legal-section">
                    <h2>9. Disclaimer of Warranties</h2>
                    <p>The website and all content, information, and services are provided on an “as is” and “as
                        available” basis without warranties of any kind, whether express or implied.</p>
                    <p>Kalpita Technologies does not guarantee that:</p>
                    <ul>
                        <li> The website will always be available, uninterrupted, or error-free </li>
                        <li> The content is accurate, complete, or current.</li>
                        <li>Defects or vulnerabilities will be corrected immediately.</li>
                        <li>The website will be free from viruses or harmful components.</li>
                    </ul>
                    <p>Use of the website is at your sole risk.</p>
                </div>

                <div class="legal-section">
                    <h2>10. Limitation of Liability</h2>
                    <p>To the fullest extent permitted by law, Kalpita Technologies shall not be liable for any direct,
                        indirect, incidental, consequential, special, or punitive damages arising out of or related to:
                    </p>
                    <ul>
                        <li>Use or inability to use the website</li>
                        <li>Errors or omissions in content</li>
                        <li>Unauthorized access to systems or data </li>
                        <li>Service interruptions</li>
                        <li>Third-party links or services</li>
                        <li>Loss of business, revenue, profits, or data</li>
                    </ul>
                    <p>This limitation applies regardless of the legal theory under which the claim arises.</p>
                </div>

                <div class="legal-section">
                    <h2>11. Indemnification</h2>
                    <p>You agree to indemnify and hold harmless Kalpita Technologies, its directors, employees,
                        affiliates, partners, and representatives from any claims, liabilities, damages, losses, or
                        expenses arising from:</p>
                    <ul>
                        <li>Your violation of these Terms</li>
                        <li>Misuse of the website</li>
                        <li>Violation of applicable laws or third-party rights</li>
                    </ul>
                </div>

                <div class="legal-section">
                    <h2>12. Privacy</h2>
                    <p>Your use of this website may involve the collection and processing of personal information. Such
                        processing shall be governed by Kalpita Technologies’ Privacy Policy.
                    </p>
                    <p>Users submitting information through contact forms, downloads, newsletters, recruitment
                        applications, or other interactions consent to the processing of their information for
                        legitimate business purposes.</p>
                </div>

                <div class="legal-section">
                    <h2>13. Security</h2>
                    <p>While Kalpita Technologies implements reasonable security measures to protect its systems and
                        information, no digital platform or internet transmission can be guaranteed to be completely
                        secure.
                    </p>
                    <p>Users are responsible for maintaining the security of their own devices, credentials, and
                        communications while interacting with the website.</p>
                </div>

                <div class="legal-section">
                    <h2>14. Changes to Terms</h2>
                    <p>Kalpita Technologies reserves the right to modify, update, or revise these Terms of Use at any
                        time without prior notice.
                    </p>
                    <p>Changes become effective immediately upon publication on this page. Continued use of the website
                        following updates constitutes acceptance of the revised Terms.</p>
                    <p>Users are encouraged to review this page periodically.</p>
                </div>

                <div class="legal-section">
                    <h2>15. Governing Law and Jurisdiction</h2>
                    <p>These Terms shall be governed by and interpreted in accordance with the laws of India.</p>
                    <p>Any disputes arising out of or relating to these Terms or use of the website shall be subject to
                        the exclusive jurisdiction of the courts located in Bengaluru, Karnataka, India.</p>
                </div>

                <div class="legal-section contact-block">
                    <h2>16. Contact Information</h2>
                    <p>For questions, concerns, or requests related to these Terms of Use, please contact: </p>
                    <p><a href="https://www.kalpitatechnologies.com/contact-us" target="_blank">Kalpita Technologies
                            Contact Page</a></p>
                    <div class="contact-details">
                        <p><strong>Kalpita Technologies Private Limited</strong></p>
                        <p>Bengaluru, Karnataka, India</p>
                        <p>Email: <a
                                href="mailto:connect@kalpitatechnologies.com">connect&#64;kalpitatechnologies.com</a>
                        </p>
                    </div>
                </div>

                <div class="legal-section">
                    <h2>17. Entire Agreement</h2>
                    <p>These Terms of Use constitute the complete agreement between the user and Kalpita Technologies
                        regarding the use of this website and supersede all prior understandings or communications
                        relating to website usage.</p>
                </div>
            </div>
        </div>
    </section>
</div>